import { autoNumericFormatter } from '../../autoNumericFormatter';

$(() => {
  if ($('#subscription-form').length === 0) {
    return;
  }

  autoNumericFormatter();
});
